import { CIcon } from '~/icons/types'

export const ciUpload: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21 13.5a1.5 1.5 0 0 0-1.5 1.5v4a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-4a1.5 1.5 0 0 0-3 0v4A3.5 3.5 0 0 0 5 22.5h14a3.5 3.5 0 0 0 3.5-3.5v-4a1.5 1.5 0 0 0-1.5-1.5Z'
    },
    {
      d:
        'm8.061 9.061 2.439-2.44V15a1.5 1.5 0 1 0 3 0V6.621l2.439 2.44a1.5 1.5 0 1 0 2.122-2.122l-5-5a1.5 1.5 0 0 0-.491-.325l-.023-.008a1.464 1.464 0 0 0-1.094 0l-.023.008a1.5 1.5 0 0 0-.491.325l-5 5a1.5 1.5 0 0 0 2.122 2.122Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'upload',
  type: 'solid'
}
